export const SEVERITY_GROUPS = [
	{ severity: "high", label: "High" },
	{ severity: "medium", label: "Medium" },
	{ severity: "low", label: "Low" },
];
